"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimulateDiscountRuleDto = exports.SimulateDiscountRuleContextDto = exports.SimulateDiscountRuleLineDto = exports.SimulateDiscountRuleLineDateDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const create_discount_rule_dto_1 = require("./create-discount-rule.dto");
class SimulateDiscountRuleLineDateDto {
    date;
    hours;
}
exports.SimulateDiscountRuleLineDateDto = SimulateDiscountRuleLineDateDto;
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], SimulateDiscountRuleLineDateDto.prototype, "date", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsNumber)({}, { each: true }),
    __metadata("design:type", Array)
], SimulateDiscountRuleLineDateDto.prototype, "hours", void 0);
class SimulateDiscountRuleLineDto {
    displayId;
    displayName;
    amountBeforeDiscounts;
    unitAmount;
    plays;
    dates;
    displayListIds;
    categoryId;
    tagIds;
    groupId;
    contextualDataServices;
}
exports.SimulateDiscountRuleLineDto = SimulateDiscountRuleLineDto;
__decorate([
    (0, class_validator_1.IsMongoId)(),
    __metadata("design:type", String)
], SimulateDiscountRuleLineDto.prototype, "displayId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SimulateDiscountRuleLineDto.prototype, "displayName", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], SimulateDiscountRuleLineDto.prototype, "amountBeforeDiscounts", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], SimulateDiscountRuleLineDto.prototype, "unitAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], SimulateDiscountRuleLineDto.prototype, "plays", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => SimulateDiscountRuleLineDateDto),
    __metadata("design:type", Array)
], SimulateDiscountRuleLineDto.prototype, "dates", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], SimulateDiscountRuleLineDto.prototype, "displayListIds", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsMongoId)(),
    __metadata("design:type", String)
], SimulateDiscountRuleLineDto.prototype, "categoryId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], SimulateDiscountRuleLineDto.prototype, "tagIds", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsMongoId)(),
    __metadata("design:type", String)
], SimulateDiscountRuleLineDto.prototype, "groupId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], SimulateDiscountRuleLineDto.prototype, "contextualDataServices", void 0);
class SimulateDiscountRuleContextDto {
    userId;
    subtotalBeforeDiscounts;
    displaysCount;
    playsCount;
    campaignDays;
    totalHours;
    displayIds;
    /**
     * Optional real campaign lines for accurate compatibility checks.
     *
     * If omitted, the backend keeps the previous lightweight simulation behaviour and
     * creates synthetic lines from the aggregate context.
     */
    lines;
    now;
}
exports.SimulateDiscountRuleContextDto = SimulateDiscountRuleContextDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsMongoId)(),
    __metadata("design:type", String)
], SimulateDiscountRuleContextDto.prototype, "userId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], SimulateDiscountRuleContextDto.prototype, "subtotalBeforeDiscounts", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(1),
    __metadata("design:type", Number)
], SimulateDiscountRuleContextDto.prototype, "displaysCount", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], SimulateDiscountRuleContextDto.prototype, "playsCount", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(1),
    __metadata("design:type", Number)
], SimulateDiscountRuleContextDto.prototype, "campaignDays", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], SimulateDiscountRuleContextDto.prototype, "totalHours", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], SimulateDiscountRuleContextDto.prototype, "displayIds", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => SimulateDiscountRuleLineDto),
    __metadata("design:type", Array)
], SimulateDiscountRuleContextDto.prototype, "lines", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], SimulateDiscountRuleContextDto.prototype, "now", void 0);
class SimulateDiscountRuleDto {
    ruleId;
    rule;
    discountCodes;
    assumeActive;
    context;
}
exports.SimulateDiscountRuleDto = SimulateDiscountRuleDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsMongoId)(),
    __metadata("design:type", String)
], SimulateDiscountRuleDto.prototype, "ruleId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_discount_rule_dto_1.CreateDiscountRuleDto),
    __metadata("design:type", create_discount_rule_dto_1.CreateDiscountRuleDto)
], SimulateDiscountRuleDto.prototype, "rule", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], SimulateDiscountRuleDto.prototype, "discountCodes", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], SimulateDiscountRuleDto.prototype, "assumeActive", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => SimulateDiscountRuleContextDto),
    __metadata("design:type", SimulateDiscountRuleContextDto)
], SimulateDiscountRuleDto.prototype, "context", void 0);
